import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actions from './actions';
import { useActions } from 'hooks/useActions';
import { Wrapper } from 'components/Layout/Layout';
import CourseContent from './CourseContent';
import CommunityPageImageAndDescription from 'components/CommunityPageImageAndDescription/CommunityPageImageAndDescription';
import { sendAnalytics } from 'functions/sendAnalytics';

export default function CourseLandingPage() {
  const { id } = useParams();

  const { error, selectedCourse } = useSelector((state) => state.CourseLandingPageReducer);

  const { getCourse } = useActions(actions);

  useEffect(() => {
    if (id) getCourse(id);
    sendAnalytics('openCourse', id);
  }, [getCourse, id]);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  return (
    <Wrapper color="transparent">
      <CommunityPageImageAndDescription selectedItem={selectedCourse} />
      {selectedCourse.syllabus && <CourseContent key={selectedCourse._id} />}
    </Wrapper>
  );
}
